import { useApp } from "@/context/AppContext";
import { CASE_LABELS } from "@/constants/content";

export const PresetPills = () => {
  const { caseStudies, activeSlug, setActiveSlug } = useApp();
  return (
    <div className="flex flex-wrap justify-center gap-2" role="group" aria-label="Case study presets" data-testid="preset-pills">
      {caseStudies.map((cs) => {
        const active = cs.slug === activeSlug;
        return (
          <button
            key={cs.slug}
            type="button"
            onClick={() => setActiveSlug(cs.slug)}
            aria-pressed={active}
            data-testid={`preset-pill-${cs.slug}`}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs transition-[border-color,background-color,color] duration-200 ${
              active ? "border-cyan-400/60 bg-cyan-500/10 text-white" : "border-white/10 bg-white/[0.03] text-slate-300 hover:border-white/25"
            }`}
          >
            <span aria-hidden="true">{cs.flag}</span>
            <span>{CASE_LABELS[cs.slug]?.short ?? cs.title}</span>
            <span className="font-mono text-[11px] text-slate-400">{cs.final_score.toFixed(1)}</span>
          </button>
        );
      })}
    </div>
  );
};
